import { gql } from '@src/lib/gql'

export const UPSERT_ADVISOR_ENGAGEMENT = gql`
  mutation UpsertAdvisorEngagement($input: UpsertAdvisorEngagementInput!) {
    upsertAdvisorEngagement(input: $input) {
      advisorEngagement {
        id
        advisorEngagementId
        categoryKey
        statusKey
        timeCommitmentTypeKeys
        compensationTypeKeys
      }
    }
  }
`
